<template>
  <EditContent property="reportPrompt" />
</template>
<script setup lang="ts">
import EditContent from "./EditContent.vue";
</script>
